import FooterMenuLink from "./FooterMenuLink"

export default FooterMenuLink;